import React from "react";

const ScannerIcon: () => JSX.Element = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 8.25C20.8661 8.25 20.75 8.13386 20.75 8V6C20.75 4.60011 20.2947 3.40264 19.4461 2.55395C18.5974 1.70525 17.3999 1.25 16 1.25H6C4.60011 1.25 3.40264 1.70525 2.55395 2.55395C1.70525 3.40264 1.25 4.60011 1.25 6V8C1.25 8.13386 1.13386 8.25 1 8.25C0.866142 8.25 0.75 8.13386 0.75 8V6C0.75 4.39454 1.28687 3.09024 2.18855 2.18855C3.09024 1.28687 4.39454 0.75 6 0.75H16C17.6055 0.75 18.9098 1.28687 19.8114 2.18855C20.7131 3.09024 21.25 4.39454 21.25 6V8C21.25 8.13386 21.1339 8.25 21 8.25ZM16 21.25H6C4.39454 21.25 3.09024 20.7131 2.18855 19.8114C1.28687 18.9098 0.75 17.6055 0.75 16V14C0.75 13.8661 0.866142 13.75 1 13.75C1.13386 13.75 1.25 13.8661 1.25 14V16C1.25 17.3999 1.70525 18.5974 2.55395 19.4461C3.40264 20.2947 4.60011 20.75 6 20.75H16C17.3999 20.75 18.5974 20.2947 19.4461 19.4461C20.2947 18.5974 20.75 17.3999 20.75 16V14C20.75 13.8661 20.8661 13.75 21 13.75C21.1339 13.75 21.25 13.8661 21.25 14V16C21.25 17.6055 20.7131 18.9098 19.8114 19.8114C18.9098 20.7131 17.6055 21.25 16 21.25ZM21 11.25H1C0.866142 11.25 0.75 11.1339 0.75 11C0.75 10.8661 0.866142 10.75 1 10.75H21C21.1339 10.75 21.25 10.8661 21.25 11C21.25 11.1339 21.1339 11.25 21 11.25Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ScannerIcon;
